import React, { useMemo } from 'react';
import AppPageHeader from '../shell/AppPageHeader';
import ChangePasswordSection from '../shared/ChangePasswordSection';
import { useFirmMainHeaderSlot } from './FirmMainHeaderContext';
import { shellMainPaddingX } from '../../utils/shellLayoutClasses';

export default function FirmSettings() {
  const firmHeader = useMemo(() => <AppPageHeader variant="firmShell" title="Settings" />, []);
  useFirmMainHeaderSlot(firmHeader);

  return (
    <main className="flex-1 flex flex-col min-h-0 min-w-0">
      <div className={`flex-1 overflow-auto pb-8 pt-3 sm:pt-4 ${shellMainPaddingX}`}>
        <div className="w-full space-y-6">
          <ChangePasswordSection />
        </div>
      </div>
    </main>
  );
}
